App.filter('titleCase', function() {
  return function(input) {
    input = input || ''
    return input.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())
  };
})
